import { useContext } from "react";
import { SmsContext } from "./context";


export function useSms() {
    const context = useContext(SmsContext)

    if (!context) {
        throw new Error('useSms must be used within the SmsProvider')
    }

    return context
}